import { createSlice } from "@reduxjs/toolkit";
import { IBlog } from "src/@types/blog";
import { BLOG_SLICE_NAME } from "./actions";
import { getBlogCurrentPostReducer } from "./reducers";

export interface CurrentBlogState {
  post: IBlog;
  isLoading: boolean;
}

const initialState: CurrentBlogState = {
  post: null,
  isLoading: false,
};

export const { reducer: currentBlog } = createSlice({
  name: BLOG_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getBlogCurrentPostReducer(builder);
  },
});
